import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=5281fccd&lang=pug&"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./PageBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports